<template>
  <div>
    <OneHead 
      :brandClass="brandClass()" :isHeader="false">
      <template v-slot:title>{{$toUpperCase($t("profile_esim_header_title"))}}</template>
      <template v-slot:subtitle>
        <span v-if="$t('profile_esim_header_subtitle_prefix')">
          {{$t('profile_esim_header_subtitle_prefix')}}
        </span>
        <span v-if="$t('profile_esim_header_subtitle_link') && !!$c('link_external_esim_page')">
          <a :href="$c('link_external_esim_page')" target="_blank" rel="noopener noreferrer" tabindex="0" @keydown="ariaClick">
            {{$t('profile_esim_header_subtitle_link')}}
          </a>
        </span>
        <span v-if="$t('profile_esim_header_subtitle_link') && !$c('link_external_esim_page')">
          {{$t('profile_esim_header_subtitle_link')}}
        </span>
        <span v-if="$t('profile_esim_header_subtitle_suffix')">
          {{$t('profile_esim_header_subtitle_suffix')}}
        </span>
       
      </template>
    </OneHead>
    <EsimNotification v-if="notificationOptions" class="esim-notification" :class="brandClass()"
                      :text="notificationOptions.text"
                      :type="notificationOptions.type"
                      :icon="notificationOptions.icon"
    >
    </EsimNotification>

    <hr alt="" role="presentation">
    <EsimSubscriptions 
            @sectionContent="$emit('sectionContent',$event)"
            @unsubscribe="subscriptionDeletedHandler()" 
            @subscriptionError="subscriptionErrorHandler($event)"
            :user="user"></EsimSubscriptions>
  </div>
</template>

<script>
import EsimSubscriptions from "@/components/ProfileForm/components/EsimSubscriptions.vue";
import EsimNotification from "@/components/ProfileForm/components/EsimNotification";
import oneUtils from "../../../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

export default {
  inject:['$c', '$t', 'brandClass', '$toUpperCase'],
  name: "EsimSection",
  components: {
    EsimNotification,
    EsimSubscriptions,
  },
  mixins: [oneUtils.accessibilityMixin],
  props: {
    user: {},
  },
  data: () => ({
    notificationOptions: null
  }),
  mounted() {
    this.checkSubscriptionResult();
  },
  methods: {
   /**
    * this function manage the subscription callback
    * and trigger the appropriate notifications
    */
    async checkSubscriptionResult() {
      // get the query parameter
      const query = Object.assign({}, oneUtils.utils.getQueryParams());
      const subscriptionResult = query.extErrorCode;
      // management of the callback
      if (subscriptionResult) {
        if(subscriptionResult!=='201'){
          let payload = oneUtils.trackingUtils.trackError(
            'esim_activation', 
            'track', 
            '',
            subscriptionResult, 
            subscriptionResult, 
            'activateEsim'
          );
        }
        switch (subscriptionResult) {
          case '201': {
            this.showNotification({
              text: this.$t('profile_esim_notification_success'),
              type: 'success',
              icon: 'check'
            });
            break;
          }
          case '401': {
            this.showNotification({
              text: this.$t('profile_esim_notification_401'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '403': {
            this.showNotification({
              text: this.$t('profile_esim_notification_403'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '10': {
            this.showNotification({
              text: this.$t('profile_esim_notification_10'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '11': {
            this.showNotification({
              text: this.$t('profile_esim_notification_11'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '12': {
            this.showNotification({
              text: this.$t('profile_esim_notification_12'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '13': {
            this.showNotification({
              text: this.$t('profile_esim_notification_13'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '19': {
            this.showNotification({
              text: this.$t('profile_esim_notification_19'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '23': {
            this.showNotification({
              text: this.$t('profile_esim_notification_23'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '24': {
            this.showNotification({
              text: this.$t('profile_esim_notification_24'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '29': {
            this.showNotification({
              text: this.$t('profile_esim_notification_29'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '30': {
            this.showNotification({
              text: this.$t('profile_esim_notification_30'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '31': {
            this.showNotification({
              text: this.$t('profile_esim_notification_31'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '39': {
            this.showNotification({
              text: this.$t('profile_esim_notification_39'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '60': {
            this.showNotification({
              text: this.$t('profile_esim_notification_60'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '90': case '500':{
            this.showNotification({
              text: this.$t('profile_esim_notification_90'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '91': {
            this.showNotification({
              text: this.$t('profile_esim_notification_91'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '92': {
            this.showNotification({
              text: this.$t('profile_esim_notification_92'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '93': {
            this.showNotification({
              text: this.$t('profile_esim_notification_93'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          case '94': case '404':{
            this.showNotification({
              text: this.$t('profile_esim_notification_94'),
              type: 'error',
              icon: 'info'
            });
            break;
          }
          default:
            this.showNotification({
              text: this.$t('profile_esim_notification_default'),
              type: 'error',
              icon: 'info'
            });
            break;
        }
        // delete query parameter from the url
        delete query.extErrorCode;
        if(this.$router)await this.$router.replace({query});
      }
    },

    /**
     * valorization of the notification option's element to 
     * inject in the EsimNotification component
     */
    showNotification(options) {
      this.notificationOptions = options;
    },

    /**
     * hide the notification options element
     */
    hideNotification() {
      this.notificationOptions = null;
    },

    /**
     * Show the subscription delete handler notifications massage
     */
    subscriptionDeletedHandler() {
      this.showNotification({
        text: this.$t('profile_esim_notification_subscription_deleted'),
        type: 'info',
        icon: 'info'
      });
    },
      
    /**
     * Show the esim notification invalidation pending message
     * if the event is equal to MNO_TOKEN_STATUS_INVALIDATION_PENDING
     */

    subscriptionErrorHandler(evt) {
      if (evt === 'MNO_TOKEN_STATUS_INVALIDATION_PENDING') {
        this.showNotification({
          text: this.$t('profile_esim_notification_subscription_invalidation_pending'),
          type: 'warning',
          icon: 'info'
        });
      }
    },
  },
};
</script>

<style lang="scss">
.esim-notification {
  margin-top: 33px;

  &.__rr {
    .notification {
      .text {
        font-family: RivieraNights-Light;
      }
    }
  }
}
</style>
